import { UPDATE_CURRENT_PAGE_FEEDS } from '../constants/currentPageFeeds';

const DEFAULT_STATE = {
  page: 1
};

export default (state = DEFAULT_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_CURRENT_PAGE_FEEDS: {
      return { ...state, ...payload };
    }
    default:
      return state;
  }
};
